// extracted by mini-css-extract-plugin
export default {"LinkWalletPopup":"LinkWalletPopup_LinkWalletPopup__U8r2V","walletForm":"LinkWalletPopup_walletForm__j-Yzn","submitBtn":"LinkWalletPopup_submitBtn__TDDPu"};